import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const PlayingIcon: React.FC<DefaultIconProps> = ({
  className, width, height, textColor = '#fff',
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 24 24">
    <g data-name="Grupo 140549">
      <g opacity="0.5">
        <path d="M0 0h24v24H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
        <path d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.7.457L12 19.03l-8.3 3.7a.5.5 0 0 1-.7-.456V3a1 1 0 0 1 1-1zm15 17.965V4H5v15.965l7-3.124zM12 13.5l-2.939 1.545.561-3.272-2.377-2.318 3.286-.478L12 6l1.47 2.977 3.285.478-2.377 2.318.56 3.272z" fill={textColor} />
      </g>
      <g data-name="bookmark-3-line">
        <path data-name="Path" d="M0 0h24v24H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
        <path data-name="Shape" d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.7.457L12 19.03l-8.3 3.7a.5.5 0 0 1-.7-.456V3a1 1 0 0 1 1-1zm15 17.965V4H5v15.965l7-3.124z" fill={textColor} />
      </g>
    </g>
  </svg>

);

export default PlayingIcon;
